export enum ErrorTitle {
    ShoppingCartItemsChanged = 'SHOPPING_CART_ITEMS_CHANGED',
}
